import { FontSizes, IconButton, Label, Separator, Text } from "@fluentui/react";
import { connect } from "react-redux";
import { useBoolean } from "@fluentui/react-hooks";
import moment from "moment";


// Functions
import * as ComponentFunctions from './SettlementSummaryItem.Functions';

//styles
import './SettlementSummaryItem.css';

// Components
import SettlementDetailsListComponet from "../SettlementDetailsList/SettlementDetailsList.Component";
import SettlementResumeFormComponent from "../SettlementResumeForm/SettlementResumeForm.Component";
import SettlementSummaryStatistic from "../SettlementSummaryStatistics/SettlementSummaryStatistic.Component";
import SettlementMoneyChartComponent from "../SettlementMoneyChart/SettlementMoneyChart.Component";
import { CharType } from "../SettlementMoneyChart/SettlementMoneyChart.Functions";
import { SettlementSummeryTotal } from "../../../models/Entities/SettlementSummaryTotals/SettlementSummeryTotal";
import { SettlementDetail } from "../../../models/Entities/SettlementDetails/SettlementDetail";
import { itemLayoutClassName } from "@fluentui/react-migration-v0-v9";
import { Subtitle1 } from "@fluentui/react-components";

const SettlementSummaryItem = (props: ComponentFunctions.Props) => {

    // Details Panel 
    const [isDetailsPanelOpen, { setTrue: openDetailsPanel, setFalse: dismissDetailsPanel }] =
        useBoolean(false);

    // Summary Form
    const [isOpenSummaryForm, { setTrue: openSummaryFormPanel, setFalse: dismissSummaryFormPanel }] =
        useBoolean(false);


    const handleDetailsClosePanel = () => {
        dismissDetailsPanel();
    }

    const handleSummaryFormClosePanel = () => {
        dismissSummaryFormPanel();
    }

    const onViewDetailsBySummary = () => {
        openDetailsPanel();
    }

    const onEditSummary = () => {
        openSummaryFormPanel();
    }

    const onDeleteSettlementResume = () => {
        //props.CurrentSummary && props.DeleteSettlementResume(props.SettlementId, props.CurrentSummary?.id);
    }

    const onMasiveExcludeSettlementResume = () => {
        //props.CurrentSummary && props.MassExclude(props.SettlementId, props.CurrentSummary.id, true);
    }

    const onMasiveIncludeSettlementResume = () => {
        //props.CurrentSummary && props.MassExclude(props.SettlementId, props.CurrentSummary.id, false);
    }

    const Options = (
        <>
            <IconButton
                iconProps={ComponentFunctions.PropertiesIcon}
                onClick={() => onViewDetailsBySummary()}
            />
            <IconButton
                iconProps={ComponentFunctions.EditIcon}
                onClick={() => onEditSummary()}
            />
            <IconButton
                iconProps={ComponentFunctions.Exclude}
                onClick={() => onMasiveExcludeSettlementResume()}
            />
            <IconButton
                iconProps={ComponentFunctions.Include}
                onClick={() => onMasiveIncludeSettlementResume()}
            />
            <IconButton
                iconProps={ComponentFunctions.DeleteIcon}
                onClick={() => onDeleteSettlementResume()}
            />
        </>
    )

    const Modals = (
        <>
            <SettlementDetailsListComponet
                isOpen={isDetailsPanelOpen}
                openPanel={openDetailsPanel}
                dismissPanel={handleDetailsClosePanel}
                SettlementId={props.SettlementId}
                SettlementResumeId={props.CurrentSummary?.id}
            />
            <SettlementResumeFormComponent
                isOpen={isOpenSummaryForm}
                openPanel={openSummaryFormPanel}
                dismissPanel={handleSummaryFormClosePanel}
                SettlementId={props.SettlementId}
                SettlementResumeId={props.CurrentSummary?.id} />
        </>
    );



    return (
        <div className={'SummaryItemContainer ' + (props.CurrentSummary?.haveWarning ? 'warning' : '')}>
            <div className="SummaryInfo">
                <Subtitle1>{props.CurrentSummary?.description}</Subtitle1>
                <ul className="TotalList">
                    {props.CurrentSummary?.totals?.map((total: SettlementSummeryTotal) =>
                        <li key={total.id}>
                            <table className='values'>
                                <thead>
                                    <tr>
                                        <th>Total</th>
                                        <th colSpan={2}>División de honorarios</th>
                                        <th>WithHolding</th>
                                        <th>Importe a cobrar</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Centro</th>
                                        <th>Equipo médico</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{total.total.toLocaleString('es-AR', { style: 'currency', currency: total.currencyCode.toUpperCase() })}</td>
                                        <td>{total.ownerAmount.toLocaleString('es-AR', { style: 'currency', currency: total.currencyCode.toUpperCase() })}</td>
                                        <td>{total.teamAmount.toLocaleString('es-AR', { style: 'currency', currency: total.currencyCode.toUpperCase() })}</td>
                                        <td>{total.totalWithholding.toLocaleString('es-AR', { style: 'currency', currency: total.currencyCode.toUpperCase() })}</td>
                                        <td>{total.ownerAmount.toLocaleString('es-AR', { style: 'currency', currency: total.currencyCode.toUpperCase() })}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    )}
                </ul>
            </div>
            <div>
                <Separator />
                <table className="SettlementSummaryTable">
                    <thead>
                        <tr>
                            <th>Paciente</th>
                            <th>Fecha</th>
                            <th>Concepto</th>
                            <th>Total</th>
                            <th>WithHolding</th>
                            <th colSpan={2}>División de honorarios</th>
                            <th>Importe a cobrar</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Centro</th>
                            <th>Equipo médico</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.SettlementDetails?.map((detail: SettlementDetail) =>
                            <tr key={detail.id}>
                                <td>{detail.patientNumberInProtocol}</td>
                                <td>{moment(detail.dueDate).format('DD/MM/YYYY')}</td>
                                <td>{detail.conceptName}</td>
                                <td style={{textAlign: 'right'}}>{detail.amount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                <td style={{textAlign: 'right'}}>({detail.withHolingPercentage}%)&nbsp;{detail.withHolingAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                <td style={{textAlign: 'right'}}>({detail.feeDivisionPercentage}%)&nbsp;{detail.ownerAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                <td style={{textAlign: 'right'}}>({detail.teamDivisionPercentage}%)&nbsp;{detail.teamAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                <td style={{textAlign: 'right'}}>{detail.ownerAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {Modals}
        </div>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementSummaryItem as any);

